import {groq} from 'next-sanity';

import type {CookieDeclarationSchema} from '@/components/content-blocks/cookie-declaration/schema';

export const COOKIE_DECLARATION_FRAGMENT = groq`
	...
`;

export type CookieDeclarationFragment = CookieDeclarationSchema;
